/** Measures the shared desktop dome across the three homepage sections. */
(function () {
  var SELECTOR_TREES = '[id^="shopify-section-"][id$="__product_list_trees"]';
  var SELECTOR_LEARNMORE = '[id^="shopify-section-"][id$="__media_with_content_learnmore"]';
  var SELECTOR_CITRUS = '[id^="shopify-section-"][id$="__section_citrus_in_life"]';

  // Below 800px the dome is painted twice: product_list_trees::before covers trees + learn-more
  // (sized by --vc-dome-fct-gci-height), then section_citrus_in_life's own .section-background
  // continues the same image. At 800px and up the ::before rule overrides `height` with
  // --vc-dome-total-height, so the gci variable is a mobile-only concern -- hence the gate below,
  // which keeps desktop on exactly the behaviour it had before.
  var MOBILE_QUERY = '(max-width: 799.98px)';
  var mobileMql = window.matchMedia(MOBILE_QUERY);
  var seamObserver = null;

  function measure() {
    var trees = document.querySelector(SELECTOR_TREES);
    var learnmore = document.querySelector(SELECTOR_LEARNMORE);
    var citrus = document.querySelector(SELECTOR_CITRUS);
    if (!trees || !learnmore || !citrus) return;

    var treesRect = trees.getBoundingClientRect();
    var learnmoreRect = learnmore.getBoundingClientRect();
    var citrusRect = citrus.getBoundingClientRect();
    var treesHeight = treesRect.height;
    var total = citrusRect.bottom - treesRect.top;

    trees.style.setProperty('--vc-dome-total-height', total + 'px');
    trees.style.setProperty('--vc-dome-fct-height', treesHeight + 'px');
    // Mobile uses separate paints; this variable sizes the first (trees + learn-more) paint.
    // Measure anchor-to-anchor so margins between sections are included.
    if (mobileMql.matches) {
      // Reach the top of the next section's own background rather than stopping at learn-more's
      // bottom edge. The two sections are flush today so both land on the same number, but any
      // strip between where this paint stops and where citrus-in-life's background starts has
      // nothing painting it and shows the white page through -- the reported intermittent line.
      // Anchoring to citrus.top removes that class of gap, and the extra pixel absorbs
      // fractional-pixel rounding, which is what exposes a hairline at non-integer zoom.
      trees.style.setProperty('--vc-dome-fct-gci-height', (citrusRect.top - treesRect.top + 1) + 'px');
    } else {
      trees.style.setProperty('--vc-dome-fct-gci-height', (learnmoreRect.bottom - treesRect.top) + 'px');
    }
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var debouncedMeasure = debounce(measure, 150);

  // The load/DOMContentLoaded pair below is a one-shot measurement, so anything that grows the
  // run between trees.top and citrus.top AFTER it -- carousel/slideshow init, late app-injected
  // markup, a font or image settling -- leaves the first paint short and reopens the seam. That
  // race is why the white line was intermittent rather than constant. Re-measure whenever any of
  // the three sections actually changes size, so the value cannot go stale.
  //
  // Mobile only, matching the variable's own scope. Changing the custom property resizes an
  // absolutely-positioned ::before, which cannot feed back into these elements' box sizes, so
  // this does not self-trigger; the debounce guards the rest.
  function syncSeamObserver() {
    if (!mobileMql.matches) {
      if (seamObserver) {
        seamObserver.disconnect();
        seamObserver = null;
      }
      return;
    }
    if (seamObserver || typeof ResizeObserver !== 'function') return;
    seamObserver = new ResizeObserver(debouncedMeasure);
    [SELECTOR_TREES, SELECTOR_LEARNMORE, SELECTOR_CITRUS].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (el) seamObserver.observe(el);
    });
  }

  function init() {
    measure();
    syncSeamObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Fonts/images can change heights after DOMContentLoaded; resize also changes breakpoints.
  window.addEventListener('load', measure);
  window.addEventListener('resize', debouncedMeasure);

  // Crossing the 800px boundary swaps which variable the ::before reads, so attach or drop the
  // mobile-only observer with it.
  if (typeof mobileMql.addEventListener === 'function') {
    mobileMql.addEventListener('change', function () {
      syncSeamObserver();
      measure();
    });
  }
})();
